<template>
    <div class="grid xl:grid-cols-3 justify-items-center grid-cols-1">
        <template v-for="(compareItem, compareIndex) in handleCompareItems">
            <AppCompareTabItem @navigateFunc="showUpgradeModal = true" :item="compareItem" />
        </template>
    </div>

    <AppButton v-if="items.length > 3" class="mx-auto" variant="ghost" @click="showMoreItems = !showMoreItems">
        {{ showMoreItems ? $t("global_showLess") : $t("global_showMore") }}
    </AppButton>
    <AppAclUpgradeModal v-model:showUpgradeModal="showUpgradeModal" />
</template>

<script setup lang="ts">
interface IProps {
    items: ICompareTabGroupItem[];
}

const props = defineProps<IProps>();

const showMoreItems = ref(false);

const handleCompareItems = computed(() => {
    if (showMoreItems.value) {
        return props.items;
    } else return props.items.slice(0, 3);
});
const showUpgradeModal = ref(false);
</script>
